import { NgTemplateOutlet } from '@angular/common';
import { Component, inject, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ActionCardStrategy } from './action-card.interface';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';
import { OCP_DIALOG_REF } from '../dialog-ref.token';

@Component({
  selector: 'ocp-action-card',
  templateUrl: './action-card.component.html',
  styleUrl: './action-card.component.scss',
  imports: [TranslatePipe, ThemedIconComponent, HlmButtonImports, NgTemplateOutlet],
})
export class ActionCardComponent {
  readonly action = output<void>();

  private readonly brnDialogRef = inject<BrnDialogRef<unknown>>(BrnDialogRef, { optional: true });
  private readonly dialogRef = inject(OCP_DIALOG_REF, { optional: true });
  protected readonly actionCardStrategy = inject(ActionCardStrategy);
  protected readonly iconName = this.actionCardStrategy.imgSrc.split('/').pop() ?? '';
  protected readonly iconMode = this.actionCardStrategy.imgMode;
  protected readonly uploadButtonIconName = this.actionCardStrategy.uploadButtonImgSrc;
  protected readonly uploadButtonIconNameMode = this.actionCardStrategy.uploadButtonImgMode;

  onActionClick(): void {
    this.brnDialogRef?.close();
    this.dialogRef?.close();
    this.action.emit();
  }
}
